<template>
  <div class="generate-result-page">
    <!-- 导航栏：统一风格 -->
    <div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
      <div class="back-btn" @click="onBack">
        <img src="@/assets/back.svg" class="back-icon" />
      </div>
      <div class="nav-title">爆款跟拍</div>
    </div>
    <div class="page-body">
      <div class="videoDiv" @click="goToVideo">
        <div class="message" v-if="!selectedVideoUrl">请选择视频</div>
        <div class="videoDivTime" v-if="this.selectedVideoUrl">
          {{ formattedTime }}
        </div>

        <img
          src="@/assets/aiVideo/sybf.png"
          alt="#"
          class="bodyTop-sybf"
          v-if="this.selectedVideoUrl"
        />

        <img :src="spfm1" alt="#" class="video" v-if="spfm1" />
      </div>
    </div>
    <div class="bottom">
      <div class="bottomBtn" @click="handleConfirm()">选择视频</div>
      <div class="bottomBtn" @click="uploadVideo">上传</div>
    </div>
    <FullScreenVideo
      :src="videoSrc"
      @error="handleVideoError"
      @goBack="goBack"
      v-if="showVideo"
    />
    <input
      ref="videoInput"
      type="file"
      accept="video/*"
      style="display: none"
      @change="handleVideoSelect"
    />
  </div>
</template>

<script>
import { extractVideoFrame } from "@/utils/videoUtils";
import FullScreenVideo from "@/components/fullScreenVideo.vue";
import uploadFileInChunks from "@/utils/uploadFileInChunks";

import { addhitVideo } from "@/api";
import { Toast } from "vant";

export default {
  name: "recordingGuide",
  components: { FullScreenVideo },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.spTime / 60)
        .toString()
        .padStart(2, "0");
      const seconds = (this.spTime % 60).toString().padStart(2, "0");
      return `${minutes}:${seconds}`;
    },
  },
  data() {
    return {
      selectedFile: null,
      selectedVideoUrl: null, // 用于预览
      spfm1: "",
      pageFile: "",
      videoSrc: "",
      showVideo: false,
      spTime: "",
	  currentPlatform: '',
    };
  },
  mounted() {
    this.$refs.videoInput.click();
	document.title = "爆款跟拍";
	this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
  },
  methods: {
    goToVideo() {
      this.showVideo = true;
      this.videoSrc = this.selectedVideoUrl;
    },
    // 返回按钮逻辑
    onBack() {
      this.$router.back();
    },
    goBack() {
      this.showVideo = false;
    },
    handleVideoError(error) {
      console.log(error);
    },
    //点击上传视频
    uploadVideo() {
      this.uploadFileNew(this.pageFile);
    },
    // 点击“我知道了”
    handleConfirm() {
      console.log("走到这里");
      // 触发隐藏 input 的点击
      this.$refs.videoInput.click();
    },
    // 处理选中的视频
    async handleVideoSelect(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.spfm1 = "";
      // 检查是否为视频
      if (!file.type.startsWith("video/")) {
        this.resetSelection();
        this.$toast && this.$toast("请选择视频文件");
        return;
      }

      // 检查时长（需用 video 元素加载后才能获取）
      this.checkVideoDuration(file);

      // 生成预览 URL
      this.selectedVideoUrl = URL.createObjectURL(file);
      //   spfm1
      try {
        const poster = await extractVideoFrame(this.selectedVideoUrl, 1, {
          maxWidth: 300,
        });
        this.spfm1 = poster;
      } catch (error) {
        this.spfm1 = "";
        this.$toast && this.$toast("生成封面失败:" + error.message);
      }
      this.selectedFile = file;
    },

    // 检查视频时长（异步）
    checkVideoDuration(file) {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        const duration = video.duration; // 单位：秒
        // if (duration > 30) {
        //   this.$toast && this.$toast("视频时长不能超过30秒！");
        //   this.resetSelection();
        // } else {
        this.spTime = String(duration).split(".")[0];
        console.log("视频时长:", duration, "秒");
        //   this.uploadFile(file);
        this.pageFile = file;
        // }
      };
      video.onerror = () => {
        this.$toast && this.$toast("无法读取视频信息");

        this.resetSelection();
      };
      video.src = URL.createObjectURL(file);
    },

    // 上传视频（示例）
    async uploadFile(videoFileUrl) {
      const params = { videoFileUrl: videoFileUrl, duration: Number(this.spTime) };
      let data = await addhitVideo(params);

      this.$router.replace({
        path: "videoTextconfirm",
        query: {
          content: data.text,
        },
      });
    },
    async uploadFileNew(file) {
      if (!file) {
        return this.$toast && this.$toast("请选择要上传的视频");
      }
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0, // 持续显示，直到关闭
      });
      try {
        const result = await uploadFileInChunks(file, {
          chunkSize: 5 * 1024 * 1024, // 5MB
          concurrent: 3, // 3 个并发
          maxRetry: 3,
          voType: "4",
          spot: "3",
          spTime: this.spTime,
          onProgress: (percent, count, total) => {
            this.progress = percent;
            console.log(`进度: ${percent}%, 已完成: ${count}/${total}`);
          },
        });
        Toast.clear();
        this.uploadFile(result.completeRes);
        // this.isLoading = false;
      } catch (err) {
        Toast.clear();

        console.error(err);
        // errorMsg.value = `上传失败: ${err.message}`;
      } finally {
        console.log("result11");
        Toast.clear();
      }
    },
    // 重置选择
    resetSelection() {
      this.selectedFile = null;
      this.selectedVideoUrl = null;
      // 清空 input 值，确保下次能触发 change
      this.$refs.videoInput.value = "";
      this.spfm1 = "";
    },
  },
};
</script>

<style scoped>
/* 页面基础布局 */
.generate-result-page {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
}

/* 导航栏（与原页面完全统一） */
.custom-nav-bar {
  width: 100%;
  height: 11.7333vw;
  background-image: linear-gradient(90deg, #e7f2fa 0%, #dbe2f1 100%);
  box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
  position: relative;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
}

.back-btn {
  width: 6.4vw;
  height: 6.4vw;
  position: absolute;
  left: 2.6667vw;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nav-title {
  font-family: SourceHanSansSC-Medium;
  font-size: 4.8vw;
  color: #000000;
  letter-spacing: 0.1333vw;
  text-align: center;
  line-height: 11.7333vw;
  font-weight: 500;
}
.page-body {
  /* overflow-y: auto; */
  padding: 5.333vw 4.2666vw 0 4.2666vw;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bodayTitle {
  height: 6.2666vw;
  color: #1f2226;
  font-weight: 700;
  font-size: 4.2666vw;
  text-align: left;
  line-height: 6.2666vw;
  opacity: 0.9;
  padding-bottom: 2.133vw;
  border-bottom: 0.2666vw solid #e4e8ec;
}
.bodayFirst {
  margin: 3.2vw 1.066vw 0 2.666vw;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  margin-bottom: 5.333vw;
}
.bodayFirstImg {
  width: 38.4vw;
  height: 42.666vw;
}
.bodayFirstTitle {
  width: 45.066vw;
  line-height: 4.4vw;
  font-family: SourceHanSansSC-regular;
  color: #1f2226;
  font-weight: 400;
  font-size: 2.9333vw;
  margin-top: 1.2vw;
}
.bodayFirstTitle > div:nth-child(2) {
  margin-top: 2.666vw;
}
.bodayFirstTitle > div:nth-child(3) {
  margin-top: 5.666vw;
}
.bodayFirstTitle > div:nth-child(4) {
  margin-top: 2.666vw;
}
.bodySecond {
  padding: 3.2vw 5.333vw 5.333vw 5.333vw;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.bodySecondItem {
  /* background-color: red;dis */
  display: flex;
  align-items: center;
  flex-direction: column;
}
.bodySecondImg {
  width: 18.666vw;
  height: 20vw;
}
.bodySecondTitle {
  margin-top: 3.466vw;
  color: #1f2226;
  font-weight: 400;
  font-size: 2.933vw;
  line-height: 4vw;
}
.bodyThird {
  width: 86.133vw;
  height: 42.666vw;
  margin-left: 2.666vw;
  margin-top: 3.2vw;
}
.bottonBtn {
  margin: 10.666vw 0 7.6vw 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn {
  width: 29.333vw;
  height: 8vw;
  border-radius: 2.1333vw;
  line-height: 8vw;
  font-size: 3.2vw;
  text-align: center;
}
.bottonBtnOne {
  margin-right: 3.2vw;

  background-color: #ebebed;
  font-weight: 500;
  color: #666666;
  opacity: 0.8;
}
.bottonBtnTwo {
  background: linear-gradient(
    148.76deg,
    rgba(47, 255, 181, 1) 0%,
    rgba(30, 137, 255, 1) 100%
  );
  color: #ffffff;
}
/* 弹窗遮罩 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* 弹窗内容 */
.modal-content {
  width: 80vw;
  height: 58.666vw;
  border-radius: 3.2vw;
  background-color: #ffffff;
}

.modal-title {
  line-height: 6.2666vw;
  color: #666666;
  font-weight: 500;
  font-size: 4.2666vw;
  text-align: center;
  padding: 5.333vw 0 4.2666vw 0;
}
.modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.modal-text {
  min-width: 44.8vw;
  color: #666666;
  font-weight: 400;
  font-size: 3.2vw;
  line-height: 4.8vw;
  margin-top: 1.0666vw;
}

.modal-confirm-div {
  display: flex;
  justify-content: center;
}
.modal-confirm-btn {
  width: 29.333vw;
  height: 10.666vw;
  border-radius: 2.1333vw;
  background-color: #ebebed;
  line-height: 10.666vw;
  text-align: center;
  opacity: 0.8;
  color: #666666;
  font-weight: 500;
  font-size: 3.2vw;
  margin-top: 5.4666vw;
}
.videoDiv {
  position: relative;
  width: 85.333vw;
  height: calc(100vh - 44vw);
  height: calc(100dvh - 44vw);
  border-radius: 4.2666vw;
  background-color: #d8d8d8;
  box-shadow: 0px 0px 1.0666vw 0px rgba(0, 0, 0, 0.1);
}
.message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.video {
  width: 100%;
  height: 100%;
  border-radius: 4.2666vw;
  object-fit: cover;
}
.bottom {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 8vw;
}
.bottomBtn {
  width: 40.333vw;
  height: 8vw;
  border-radius: 2.1333vw;
  background: linear-gradient(
    148.76deg,
    rgba(47, 255, 181, 1) 0%,
    rgba(30, 137, 255, 1) 100%
  );
  color: #ffffff;
  font-weight: 500;
  font-size: 3.2vw;
  text-align: center;
  line-height: 8vw;
}
.bodyTop-sybf {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8vw;
  height: 8vw;
}
.videoDivTime {
  position: absolute;
  bottom: 5.0666vw;
  left: 10vw;
  height: 7.8666vw;
  color: #ffffff;
  font-weight: 500;
  font-size: 5.333vw;
  text-align: left;
}
</style>
